import React from 'react';
import styled from 'styled-components';

import { DebugDiv } from '../../../../../components/Debug';
import { HermesysColors } from '../../../Colors';
import { formatLabel, MenuButtonProps, StyledToggleButtonContainer } from '../MenuButton';

const ToggleOptions = styled.div`
  display: grid;
  grid-auto-flow: column;
  height: 25px;
`;

const Option = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ActiveOption = styled.span`
  background: ${HermesysColors.Blue};
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ToggleButton = ({ item, buttonIdentifier }: MenuButtonProps) => {
  const options = item?.attributes?.options || [];
  const value = item?.attributes?.value || '';
  return (
    <StyledToggleButtonContainer>
      <DebugDiv>{buttonIdentifier}</DebugDiv>
      {formatLabel(item.label)}
      <ToggleOptions>
        {options.map((option) => {
          if (value == option) {
            return <ActiveOption>{option}</ActiveOption>;
          }
          return <Option key={option}>{option}</Option>;
        })}
      </ToggleOptions>
    </StyledToggleButtonContainer>
  );
};

export default ToggleButton;
